var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSalesData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 126,
    viewBox: "0 0 120 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7431 106.753C86.8358 106.753 108.807 84.1775 108.807 56.2998C108.807 28.4221 86.8358 5.84625 59.7431 5.84625C32.6504 5.84625 10.679 28.4221 10.679 56.2998C10.679 84.1775 32.6504 106.753 59.7431 106.753Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3261 49.7151V80.5859C97.3261 86.9995 92.2875 92.2159 86.01 92.2159H33.6418C27.4469 92.2159 22.4083 87.085 22.3257 80.6714C22.3257 80.5859 22.3257 80.5859 22.3257 80.5004V49.7151C22.3257 49.6296 22.3257 49.6296 22.3257 49.5441C22.3257 49.3731 22.3257 49.2021 22.4083 49.031C22.4909 48.7745 22.5735 48.6035 22.6561 48.3469L36.698 20.5547C37.1936 19.443 38.2674 18.8444 39.4238 18.8444H80.1454C81.3018 18.8444 82.293 19.443 82.8712 20.5547L96.9131 48.3469C96.9957 48.5179 97.0783 48.7745 97.1609 49.031C97.3261 49.2021 97.3261 49.4586 97.3261 49.7151Z",
    fill: "#D5DDEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_401_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.3261 49.7152V83.75C97.3261 88.4533 93.6917 92.2159 89.0661 92.2159H30.5856C26.0427 92.2159 22.3257 88.4533 22.3257 83.75V49.5442C22.3257 49.3732 22.3257 49.2022 22.4083 49.0311H41.241C44.0494 49.0311 46.3622 51.34 46.3622 54.333C46.3622 55.7868 46.9404 57.155 47.849 58.0957C48.8401 59.1218 49.9965 59.6349 51.4833 59.6349H68.251C71.0594 59.6349 73.3722 57.326 73.3722 54.333C73.3722 52.8793 73.9504 51.511 74.859 50.5704C75.8502 49.5442 77.0066 49.0311 78.4108 49.0311H97.1609C97.3261 49.2022 97.3261 49.4587 97.3261 49.7152Z",
    fill: "url(#paint0_linear_401_172)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.553 32.1847C109.424 32.1847 110.94 30.6149 110.94 28.6786C110.94 26.7422 109.424 25.1725 107.553 25.1725C105.683 25.1725 104.167 26.7422 104.167 28.6786C104.167 30.6149 105.683 32.1847 107.553 32.1847Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.167 20.8113C105.444 20.8113 106.48 19.7393 106.48 18.4169C106.48 17.0945 105.444 16.0225 104.167 16.0225C102.89 16.0225 101.854 17.0945 101.854 18.4169C101.854 19.7393 102.89 20.8113 104.167 20.8113Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4988 28.6786C11.7761 28.6786 12.8116 27.6066 12.8116 26.2842C12.8116 24.9618 11.7761 23.8898 10.4988 23.8898C9.22151 23.8898 8.18604 24.9618 8.18604 26.2842C8.18604 27.6066 9.22151 28.6786 10.4988 28.6786Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29518 81.3555C7.66734 81.3555 9.59036 79.3647 9.59036 76.9088C9.59036 74.4529 7.66734 72.462 5.29518 72.462C2.92302 72.462 1 74.4529 1 76.9088C1 79.3647 2.92302 81.3555 5.29518 81.3555Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.492 8.55621C81.57 20.7396 82.109 23.5297 79.6683 34.5634C78.8746 37.0164 78.0809 39.7031 76.3801 41.572C73.999 44.4923 69.6902 45.7772 66.1752 44.8427C62.5468 43.9082 59.5988 40.6376 58.9184 36.666C58.3515 34.213 59.1452 31.2927 61.1862 29.7742C63.3405 28.3725 66.402 28.7229 68.2162 30.475C70.2572 32.2272 71.0509 34.9138 70.9375 37.4837C70.8241 40.0535 69.917 42.6233 68.6698 44.8427C65.8502 50.3 64.6895 50.2799 58.9185 59.2427",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8139 4.01867C86.383 5.6467 84.659 6.23871 82.935 5.20269C81.0674 4.31468 79.7744 3.57467 80.0617 2.09465C80.4927 0.614624 82.2167 0.466621 84.228 0.318619C86.6703 0.0226148 87.1013 2.39065 86.8139 4.01867Z",
    fill: "#DAE2EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8782 5.49857C73.5966 6.83059 75.6079 7.7186 77.0445 6.38658C78.6248 4.90656 79.9178 3.87055 79.1995 2.39053C78.4812 1.05851 77.3318 1.50251 74.8895 1.79852C72.8782 2.24252 72.0163 4.01855 72.8782 5.49857Z",
    fill: "#DAE2EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1996 0.0226656C80.2052 -0.125337 81.2109 0.466672 81.4982 1.35469C81.6419 1.65069 81.7855 2.0947 81.7855 2.3907C82.0729 4.46273 81.3545 6.23876 80.2052 6.38676C78.9122 6.68276 77.6193 5.20274 77.4756 3.27871C77.4756 2.6867 77.4756 2.3907 77.4756 1.94669C77.6193 0.910679 78.1939 0.170668 79.1996 0.0226656C79.1996 0.0226656 79.3432 0.0226656 79.1996 0.0226656Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4014 71.9144C51.448 71.9144 52.2965 71.036 52.2965 69.9524C52.2965 68.8689 51.448 67.9905 50.4014 67.9905C49.3548 67.9905 48.5063 68.8689 48.5063 69.9524C48.5063 71.036 49.3548 71.9144 50.4014 71.9144Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2498 71.9144C70.2964 71.9144 71.1449 71.036 71.1449 69.9524C71.1449 68.8689 70.2964 67.9905 69.2498 67.9905C68.2032 67.9905 67.3547 68.8689 67.3547 69.9524C67.3547 71.036 68.2032 71.9144 69.2498 71.9144Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8989 84.7998H56.9575C56.0356 84.7998 55.2673 84.0044 55.2673 83.0499C55.2673 82.0954 56.0356 81.3 56.9575 81.3H62.8476C63.7696 81.3 64.5379 82.0954 64.5379 83.0499C64.5891 84.0044 63.8208 84.7998 62.8989 84.7998Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_401_172",
    x: 0.325684,
    y: 38.0311,
    width: 119,
    height: 87.1848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_401_172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_401_172",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_172",
    x1: 59.8015,
    y1: 48.0322,
    x2: 59.8015,
    y2: 92.6815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSalesData);
export default __webpack_public_path__ + "static/media/NoSalesData.69a02acd9cefc1940406ee7f02d47bc8.svg";
export { ForwardRef as ReactComponent };